import { AxiosError } from 'axios';
import { useState } from 'react';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../../models/https';
import useHttps from '../../useHttps';
import { useAppDisPatch } from '../../../redux/store';
import { totalApplicationsCountActions } from '../../../redux/slices/totalApplicationsCountSlice';

const useGetTotalApplicationsCount = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDisPatch();

  const onGetTotalApplicationsCountError = (
    err: AxiosError<ErrorHttpResponse>
  ) => {
    console.error(
      err?.message ??
        'Something went wrong while fetching total applications count'
    );
  };

  const onGetTotalApplicationsCountSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<number>) => {
    dispatch(totalApplicationsCountActions.setTotalCount(data));
  };

  const getTotalApplicationsCount = async (): Promise<void> => {
    const url: HttpConfig = {
      url: `jobs-service/applications/count`,
      method: 'get',
    };

    return await request(
      url,
      onGetTotalApplicationsCountSuccess,
      setLoading,
      onGetTotalApplicationsCountError
    );
  };

  return { getTotalApplicationsCount, loading };
};

export default useGetTotalApplicationsCount;
